import { Component, OnInit, ViewChild } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { SharedService } from "../../shared/shared.service";
import { BehaviorSubject, Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { EscalationService } from "./escalation.service";
import moment from "moment";

@Component({
    selector: 'app-escalation-matrix',
    templateUrl: './escalation-matrix.component.html',
    styleUrls: ['./escalation-matrix.component.scss'],
    standalone: false
})
export class EscalationMatrixComponent implements OnInit {
    bucketurl = environment.bucketUrl;
    escalationForm: FormGroup;
    escalationHoursForm: FormGroup;
    submitted = false;
    isEdit = false;
    dealers: any[] = [];
    isLoading = new BehaviorSubject<boolean>(false);
    ELEMENT_DATA: any[] = [];
    dayhours: { value: number, display: string }[] = [];
    options = [
        { id: 'Digital Desk', label: 'Digital Desk' },
        { id: 'Sales Manager', label: 'Sales Manager' },
    ];
    esc_type = [
        { id: 'untouched', label: 'Untouched' },
    ];
    esc_level = [
        { id: 'team_lead', label: 'Team Lead' },
        { id: 'area_manager', label: 'Area Manager' },
    ];
    esc_mode = [
        { id: 'whatsapp', label: 'WhatsApp' },
        { id: 'email', label: 'Email' },
    ];
    minutes = [
        { id: '5', label: '5 Mins' },
        { id: '10', label: '10 Mins' },
        { id: '15', label: '15 Mins' },
        { id: '30', label: '30 Mins' },
        { id: '45', label: '45 Mins' },
    ];
    hoursArr = [
        { id: '1_hr', label: '1 Hour' },
        { id: '2_hr', label: '2 Hours' },
        { id: '3_hr', label: '3 Hours' },
        { id: '4_hr', label: '4 Hours' },
        { id: '5_hr', label: '5 Hours' },
        { id: '6_hr', label: '6 Hours' },
    ];
    daysArr = [
        { id: '1_d', label: '1 Day' },
        { id: '2_d', label: '2 Days' },
        { id: '3_d', label: '3 Days' },
        { id: '4_d', label: '4 Days' },
        { id: '5_d', label: '5 Days' },
        { id: '6_d', label: '6 Days' },
        { id: '7_d', label: '7 Days' },
        { id: '8_d', label: '8 Days' },
        { id: '9_d', label: '9 Days' },
        { id: '10_d', label: '10 Days' },
    ];
    startHourArr = [
        { id: '8_am', label: '8 AM' },
        { id: '9_am', label: '9 AM' },
        { id: '10_am', label: '10 AM' },
        { id: '11_am', label: '11 AM' },
    ];

    endHourArr = [
        { id: '5_pm', label: '5 PM' },
        { id: '6_pm', label: '6 PM' },
        { id: '7_pm', label: '7 PM' },
        { id: '8_pm', label: '8 PM' },
        { id: '9_pm', label: '9 PM' },
        { id: '10_pm', label: '10 PM' },
    ];
    nonEscalationDate: any = null;
    dropdownSettingsMode = {
        singleSelection: false,
        enableCheckAll: false,
        idField: 'id',
        textField: 'label',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: false,
        closeDropDownOnSelection: true
    };
    displayedColumns: string[] = [
        "SNo",
        "user_type",
        "escalation_level",
        "interval",
        "escalation_mode",
        // "status",
        "action",
    ];
    dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    searchInput = new FormControl("");
    isCreate = false;
    masters: any = [];
    dropdownSettingsProCategory = {};
    statusList = [{ id: 1, name: "Active" }, { id: 0, name: "Inactive" }];
    selectedObject: any = {};

    @ViewChild(MatSort, { static: true }) sort!: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
    escalates = false;
    outlet_id: any;

    constructor(
        private toastr: ToastrService,
        private fb: FormBuilder,
        private sharedService: SharedService,
        private escalationService: EscalationService
    ) {
        this.escalationForm = this.fb.group({
            user_type: ["", Validators.required],
            escalation_type: ["", Validators.required],
            escalation_level: ["", Validators.required],
            email: ["", Validators.required],
            contact: ["", Validators.required],
            minutes: [""],
            hours: [""],
            days: [""],
            // startHour: [''],
            // endHour: ['',],
            nonEscalationDate: [null],
            nonEscalationDateEnd: [null],
            escalation_mode: [[], Validators.required],
        });
        this.escalationHoursForm = this.fb.group({
            working_hour_from: ['', Validators.required],
            working_hour_to: ['', Validators.required],
            non_escalation_days_from: [null],
            non_escalation_days_to: [null]
        });
    }

    ngOnInit() {
        this.getEscalation();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

        setTimeout(() => {
            const masters = JSON.parse(sessionStorage.getItem("masters") || "{}");
            if (masters) {
                this.masters = masters;
                this.dealers = this.masters.outlets || [];
            }
        }, 700);

        this.dropdownSettingsProCategory = {
            singleSelection: false,
            enableCheckAll: true,
            idField: "id",
            textField: "outlet_name",
            selectAllText: "Select All",
            unSelectAllText: "UnSelect All",
            itemsShowLimit: 1,
            allowSearchFilter: true,
        };

        this.dayhours = [
            ...Array.from({ length: 12 }, (_, i) => ({
                value: i + 1,
                display: `${i + 1} AM`
            })),
            ...Array.from({ length: 12 }, (_, i) => ({
                value: i + 1,
                display: `${i + 1} PM`
            }))
        ];

        this.escalationForm.get('minutes')?.valueChanges.subscribe(value => {
            if (value) {
                this.resetHoursAndDays();
            }
        });

        this.escalationForm.get('hours')?.valueChanges.subscribe(value => {
            if (value) {
                this.resetMinutesAndDays();
            }
        });

        this.escalationForm.get('days')?.valueChanges.subscribe(value => {
            if (value) {
                this.resetMinutesAndHours();
            }
        });

        if (sessionStorage.getItem('loginResponse')) {
            const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
            if (loginResponse && loginResponse.data) {
                this.outlet_id = loginResponse.data?.user?.outlet_id;
                console.log(this.outlet_id);
            }
        }
    }

    resetMinutesAndDays() {
        this.escalationForm.patchValue({
            minutes: '',
            days: ''
        });
    }

    resetHoursAndDays() {
        this.escalationForm.patchValue({
            hours: '',
            days: ''
        });
    }

    resetMinutesAndHours() {
        this.escalationForm.patchValue({
            minutes: '',
            hours: ''
        });
    }

    onOptionChange() {
        // Reset forms or perform other actions if needed
    }

    get f() {
        return this.escalationForm.controls;
    }

    add() {
        this.isCreate = true;
        this.showInterval = true;
    }
    enableInterval(){
        this.showInterval = !this.showInterval;
    }
    escalate() {
        this.getEscalationHours();
        this.escalates = true;
    }


    loadMasterRecords() {
        const masters = JSON.parse(sessionStorage.getItem("masters") || "{}");
        if (masters) {
            this.masters = masters;
            this.dealers = this.masters.outlets || [];
        }
    }

    editData(object: any) {
        this.showInterval = false;
        this.isEdit = true;
        this.selectedObject = object;

        this.loadMasterRecords();
        let mode:any = object.escalation_mode
        const filteredEscMode = this.esc_mode.filter((item:any) => mode.includes(item.id));
        console.log("object: ",object)
        this.escalationForm.patchValue({
            outlet_id: object.outlet_id,
            user_type: object.user_type,
            name: object.name,
            escalation_type: object.escalation_type,
            escalation_level: object.escalation_level, // Correctly set the readable label here
            email: object.email,
            contact: object.contact_no,
            interval: object.minutes || object.hours || object.days || 0,
            escalation_mode: filteredEscMode,
            // nonEscalationDate: object.nonEscalationDate || null, 
            // nonEscalationDateEnd: object.nonEscalationDateEnd || null,
        });
    }

    update() {
        this.submitted = true;

        if (this.escalationForm.valid) {
             const escalationData = { ...this.escalationForm.value };
            // escalationData.status = parseInt(escalationData.status);
            // escalationData.interval = this.getIntervalValue(); // Use the new method here
            let mode:any = this.escalationForm.value.escalation_mode.map((item:any)=> item.id)
            let request = {
                outlet_id: this.outlet_id || null,
                user_type: this.escalationForm.value.user_type,
                name: this.escalationForm.value.user_type,
                escalation_type: this.escalationForm.value.escalation_type,
                escalation_level: this.escalationForm.value.escalation_level,
                email: this.escalationForm.value.email,
                contact_no: this.escalationForm.value.contact,
                interval: this.showInterval ? this.getIntervalValue() : this.selectedObject.interval, // Use the new method here
                escalation_mode: mode.join(','),
                status :escalationData.status ? parseInt(escalationData.status): 0
            };
            this.isLoading.next(true);

            this.escalationService.updateEscalation(request, this.selectedObject.id).subscribe(
                (response: any) => {
                    if (response.body?.responseCode === 200) {
                        this.toastr.success("Escalation updated successfully!");
                        this.back(); // Navigate back to the previous page
                    } else {
                        this.toastr.error(response.body?.responseMessage || 'Unknown error');
                    }
                    this.isLoading.next(false);
                },
                (err: any) => {
                    this.isLoading.next(false);
                }
            );
        }
    }

    getIntervalValue(): number {
        const minutes = this.escalationForm.value.minutes;
        const hours = this.escalationForm.value.hours;
        const days = this.escalationForm.value.days;

        if (minutes) {
            return parseInt(minutes);
        } else if (hours) {
            return parseInt(hours) * 60; // Convert hours to minutes
        } else if (days) {
            return parseInt(days) * 1440; // Convert days to minutes (24 * 60)
        }

        return 0; // Default to 0 if nothing is selected
    }

    showInterval:boolean = false;
    back() {
        this.clearForm();
        this.selectedObject = {};
        this.isCreate = false;
        this.escalates = false;
        this.isEdit = false;
        this.getEscalation();

        this.escalationHoursForm.reset({
            working_hour_from: "",
            working_hour_to: "",
            non_escalation_days_from: null,
            non_escalation_days_to: null
        });
    }
    createEscalation() {
        this.submitted = true;
        if (this.escalationForm.valid) {
            let mode:any = this.escalationForm.value.escalation_mode.map((item:any)=> item.id)
            const escalationData = {
                outlet_id: this.outlet_id || null,
                user_type: this.escalationForm.value.user_type,
                name: this.escalationForm.value.user_type,
                escalation_type: this.escalationForm.value.escalation_type,
                escalation_level: this.escalationForm.value.escalation_level,
                email: this.escalationForm.value.email,
                contact_no: this.escalationForm.value.contact,
                interval: this.getIntervalValue(), // Use the new method here
                escalation_mode: mode.join(','),
                // nonEscalationDate: this.escalationForm.value.nonEscalationDate, // New field
                // nonEscalationDateEnd: this.escalationForm.value.nonEscalationDateEnd, // New field
            };

            this.isLoading.next(true);

            this.escalationService.createEscalation(escalationData).subscribe(
                (response: any) => {
                    if (response.body?.responseCode === 200) {
                        this.toastr.success("Escalation created successfully!");
                        this.back();
                    } else {
                        this.toastr.error(response.body?.responseMessage || 'Unknown error');
                    }
                    this.isLoading.next(false);
                },
                (err: any) => {
                    this.isLoading.next(false);
                }
            );
        }
    }

    createEscalationHours() {
        this.submitted = true;
        if (this.escalationHoursForm.valid) {
            const workingHourFrom = this.formatTime(this.escalationHoursForm.value.working_hour_from);
            const workingHourTo = this.formatTime(this.escalationHoursForm.value.working_hour_to);

            // Format non-escalation days with time
            const nonEscalationDaysFrom = this.formatDate(this.escalationHoursForm.value.non_escalation_days_from, workingHourFrom);
            const nonEscalationDaysTo = this.formatDate(this.escalationHoursForm.value.non_escalation_days_to, workingHourTo);
            if (moment(this.escalationHoursForm.value.non_escalation_days_from).format('YYYY-MM-DD') > moment(this.escalationHoursForm.value.non_escalation_days_to).format('YYYY-MM-DD')) {
                this.toastr.error("The to date should be greater than or equal to the from date!");
                return;
             } 
            const escalationHoursData = {
                working_hour_from: workingHourFrom,
                working_hour_to: workingHourTo,
                non_escalation_days_from: nonEscalationDaysFrom,
                non_escalation_days_to: nonEscalationDaysTo,
            };

            this.isLoading.next(true);

            // Pass the outlet_id here
            this.escalationService.createEscalationHours(escalationHoursData, this.outlet_id).subscribe(
                (response: any) => {
                    if (response.body?.responseCode === 200) {
                        this.toastr.success("Escalation Hours created successfully!");
                        this.back();
                    } else {
                        this.toastr.error(response.body?.responseMessage || 'Unknown error');
                    }
                    this.isLoading.next(false);
                },
                (err: any) => {
                    this.isLoading.next(false);
                }
            );
        }else{
            return
        }
    }

    formatTime(time: string): string {
        return time ? `${time}:00` : '';
    }


    formatDate(date: any, time: string): string {
        if (!date || !time) return '';

        // Combine date and time into a single moment object
        const formattedDate = moment(date).set({
            hour: parseInt(time.split(':')[0]),
            minute: parseInt(time.split(':')[1]),
            second: 0,
            millisecond: 0
        });

        // Return formatted string in the desired format
        return formattedDate.format('YYYY-MM-DDTHH:mm:ss+00:00');
    }


    getEscalation() {
        this.isLoading.next(true);
        this.escalationService.getEscalation().subscribe(
            (response: any) => {
                if (response.body?.responseCode === 200) {
                    this.ELEMENT_DATA = response.body.data.map((item: any) => ({
                        ...item,
                        email_name: this.capitalizeAndRemoveUnderscores(item.email_name)
                    }));
                    this.dataSource.data = this.ELEMENT_DATA;
                }
                this.isLoading.next(false);
            },
            (err: any) => {
                this.isLoading.next(false);
            }
        );
    }

    capitalizeAndRemoveUnderscores(value: string): string {
        if (!value) return '-';
        return value
            .replace(/_/g, ' ')
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    clearForm() {
        this.submitted = false;
        this.escalationForm.reset({
            user_type: "",
            escalation_type: "",
            escalation_level: "",
            email: "",
            contact: "",
            minutes: "",
            hours: "",
            days: "",
        });
    }

    hoursDataPkId:any = null
    getEscalationHours(){
        this.escalationService.getEscalationHours(this.outlet_id).subscribe((response: any) => {
            this.hoursDataPkId = null
                if (response.body?.responseCode === 200) {
                  let responseData:any = response.body.data
                  this.hoursDataPkId = responseData.id
                  this.escalationHoursForm.patchValue({
                    working_hour_from: responseData.working_hour_from ? this.formatWorkingHour(responseData.working_hour_from):'',
                    working_hour_to: responseData.working_hour_to ? this.formatWorkingHour(responseData.working_hour_to) : '',
                    non_escalation_days_from: new Date(responseData.non_escalation_days_from.split('T')[0]),
                    non_escalation_days_to: new Date(responseData.non_escalation_days_to.split('T')[0]),
                  })
                }
                this.isLoading.next(false);
            },
            (err: any) => {
                this.isLoading.next(false);
            });
        }
        getEscalationModes(mode:any) {
            try {
                // Try to parse the string as JSON
                return JSON.parse(mode).join(',');
              } catch (e:any) {
                // If it's not valid JSON, return the original string
                return mode;
              }
            }
          
            formatWorkingHour(time: string): string {
                // Check if the time ends with ":00" and contains a colon
                if (time.endsWith(":00") && time.includes(":")) {
                  return time.slice(0, -3); // Remove the last ":00"
                }
                
                // If the time format is "HH.MM", return as-is
                if (time.match(/^\d{2}\.\d{2}$/)) {
                  return time; // Return "09.00", "09.30", etc., unchanged
                }
                
                // If the time format is "HH:MM", return as-is
                if (time.match(/^\d{2}:\d{2}$/)) {
                  return time; // Return "09:30", "10:45", etc., unchanged
                }
              
                return time; // Return the original time if it does not match any condition
              }

              allowNumbersOnly(event: any) {
                this.sharedService.allowNumbersOnly(event);
            }
}
